// src/data/exercises/L3_03.js

const accountOptions = [
  '買掛金', '商品', '未払金', '仮払消費税', '仮受消費税'];

export const L3_03 = {
  title: '簿記　3級（第219-3回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
        { type: 'ruby', text: '熊本', ruby: 'くまもと' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '仕入先', ruby: 'しいれさき' },
        { type: 'text', value: 'から' },
        { type: 'ruby', text: '商品', ruby: 'しょうひん' },
        { type: 'text', value: '￥275,000（うち' },
        { type: 'ruby', text: '消費税額', ruby: 'しょうひぜいがく' },
        { type: 'text', value: '￥25,000）を' },
        { type: 'ruby', text: '購入', ruby: 'こうにゅう' },
        { type: 'text', value: 'し，' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '掛', ruby: 'か' },
        { type: 'text', value: 'けとした。ただし，' },
        { type: 'ruby', text: '当社', ruby: 'とうしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '商品売買取引', ruby: 'しょうひんばいばいとりひき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '関', ruby: 'かん' },
        { type: 'text', value: 'して，' },
        { type: 'ruby', text: '販売', ruby: 'はんばい' },
        { type: 'text', value: 'のつど' },
        { type: 'ruby', text: '売上原価', ruby: 'うりあげげんか' },
        { type: 'ruby', text: '勘定', ruby: 'かんじょう' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '振', ruby: 'ふ' },
        { type: 'text', value: 'り' },
        { type: 'ruby', text: '替', ruby: 'か' },
        { type: 'text', value: 'える' },
        { type: 'ruby', text: '方法', ruby: 'ほうほう' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '売上原価対立法', ruby: 'うりあげげんかたいりつほう' },
        { type: 'text', value: '）で' },
        { type: 'ruby', text: '記帳', ruby: 'きちょう' },
        { type: 'text', value: 'している。なお，' },
        { type: 'ruby', text: '消費税', ruby: 'しょうひぜい' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '税抜方式', ruby: 'ぜいぬきほうしき' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '処理', ruby: 'しょり' },
        { type: 'text', value: 'する。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '商品', debitAmount: 250000, creditAccount: '買掛金', creditAmount: 275000 },
        { debitAccount: '仮払消費税', debitAmount: 25000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '商品￥275,000（うち消費税額￥25,000）を購入、 \n' },
          { type: 'text', value: '①商品を購入なので、「仕入」と記入したいが、売上原価対立法なので \n' },
          { type: 'text', value: '「仕入」ではなく、商品が増加（プラス）します。 \n' },
          { type: 'text', value: '商品の金額は、275,000－消費税額25,000＝？ \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '商品￥275,000（うち消費税額￥25,000）を購入、 \n' },
          { type: 'text', value: '②仕入れの消費税なので、仮払消費税が増加（プラス）します。\n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '代金は掛けとした。 \n' },
          { type: 'text', value: '③仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。 \n' },
          { type: 'styled', value: '買掛金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`商品￥275,000（うち消費税額￥25,000）を購入、
①商品を購入なので、「仕入」と記入したいが、売上原価対立法なので
「仕入」ではなく、商品が増加（プラス）します。
商品の金額は、275,000－消費税額25,000＝？

商品￥275,000（うち消費税額￥25,000）を購入、
②仕入れの消費税なので、仮払消費税が増加（プラス）します。

代金は掛けとした。
③仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '商品￥275,000（うち消費税額￥25,000）を購入、 \n' },
          { type: 'text', value: '①商品を購入なので、「仕入」と記入したいが、売上原価対立法なので \n' },
          { type: 'text', value: '「仕入」ではなく、商品が増加（プラス）します。 \n' },
          { type: 'text', value: '商品の金額は、275,000－消費税額25,000＝？ \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '商品￥275,000（うち消費税額￥25,000）を購入、 \n' },
          { type: 'text', value: '②仕入れの消費税なので、仮払消費税が増加（プラス）します。\n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '代金は掛けとした。 \n' },
          { type: 'text', value: '③仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。 \n' },
          { type: 'styled', value: '買掛金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
          }
        ],
       
      },
    },
  ],
};